export default __webpack_public_path__ + "static/media/devto-icon.3233e478.svg";